<template>
  <div class="test-heading">
    <div class="case-creation__card">
      <div class="text-information-card">
        <div class="case-creation__heading border-bottom-none">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-test-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">Test Information</h3>
          </div>
        </div>
        <div class="test-information-header"></div>
      </div>
    </div>
  </div>

  <section
    class="selected-tests-information"
    v-if="
      panelsTestsData.selectedTestIds &&
      panelsTestsData.selectedTestIds.length > 0
    "
  >
    <el-checkbox-group
      v-model="panelsTestsData.selectedTestIds"
      class="case-vue-tabs"
    >
      <el-tabs>
        <el-tab-pane
          v-for="(test, index) of getSelectedCaseTypes()"
          :key="index"
        >
          <template #label>
            {{ index + 1 }}. {{ caseTypeMap[test.case_type_code] }}
          </template>
          <div v-if="test.case_type_code == 'TOXICOLOGY'">
            <ToxicologyTestsPreview
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            ></ToxicologyTestsPreview>
          </div>
          <div v-else-if="test.case_type_code == 'WOUND'">
            <WoundPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            ></WoundPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'UTI'">
            <UTIPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            ></UTIPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'URINE_CULTURE'">
            <UrineCulturePanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            ></UrineCulturePanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'ENT'">
            <EntPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            ></EntPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
            <BloodPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            ></BloodPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'STI'">
            <GTIWomensHealthTests
              :panelTestsData="panelsTestsData"
              :newCase="checkCaseValidation"
              :test="test"
              :allSelectedTests="allTests"
            ></GTIWomensHealthTests>
          </div>
          <div v-else-if="test.case_type_code == 'URINALYSIS'">
            <UrinalysisTestsPreview
              :panelTestsData="panelsTestsData"
              :newCase="checkCaseValidation"
              :test="test"
              :allSelectedTests="allTests"
            ></UrinalysisTestsPreview>
          </div>
          <div v-else-if="test.case_type_code == 'RESPIRATORY_PATHOGEN_PANEL'">
            <RespiratoryTestsPreview
              :panelTestsData="panelsTestsData"
              :newCase="checkCaseValidation"
              :test="test"
              :allSelectedTests="allTests"
            ></RespiratoryTestsPreview>
          </div>
          <div v-else>
            <DefaultPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :testType="test"
              :allSelectedTests="allTests"
              :caseType="test.case_type_code"
            ></DefaultPanelSelectedTests>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-checkbox-group>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/ReceivedSendoutsWoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const UrineCulturePanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UrineCulturePanelSelectedTests"
  )
);
const EntPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/EntPanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const GTIWomensHealthTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
const RespiratoryTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/RespiratoryTestsPreview")
);
export default {
  components: {
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    UrineCulturePanelSelectedTests,
    EntPanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    GTIWomensHealthTests,
    UrinalysisTestsPreview,
    RespiratoryTestsPreview
  },
  mixins: [UserPermissionsHelper],
  data() {
    return {
      loading: false,
      selectedTestIds: [],
      allTests: [],
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
    };
  },
  mounted() {
    this.checkSendOutInformation();
  },
  computed: {
    ...mapGetters("sendOuts", ["getReceivedSendOutInformation"]),
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },

    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }

      return data;
    },
  },
  methods: {
    async checkSendOutInformation() {
      this.loading = true;
      this.sendOutId = this.$route.params.send_out_id;

      if (!this.sendOutId) {
        this.loading = false;
        this.$router.push({
          to: "/all-received-senouts",
        });
      } else {
        await this.$store.dispatch("sendOuts/fetchReceivedSendOutInformation", {
          send_out_id: this.sendOutId,
        });
        if (!this.getReceivedSendOutInformation) {
          this.disablePatientInformation = true;
        }
        if (
          this.getReceivedSendOutInformation &&
          this.getReceivedSendOutInformation.tests_info
        ) {
          this.panelsTestsData.selectedTestIds =
            this.getReceivedSendOutInformation.tests_info.map((el) => el._id);
        }
        if (
          this.getReceivedSendOutInformation.coriell_test_panels &&
          this.getReceivedSendOutInformation.coriell_test_panels.length
        ) {
          this.panelsTestsData.selectedCoriellPanels =
            this.getReceivedSendOutInformation.coriell_test_panels;
        }
        this.allTests = this.getReceivedSendOutInformation.tests_info;

        this.loading = false;
      }
    },
    getSelectedCaseTypes() {
      if (
        this.getReceivedSendOutInformation.case_types &&
        this.getReceivedSendOutInformation.case_types.length
      ) {
        let data = this.panelsTestsData.selectedCategories
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.test-heading {
  .case-creation__card {
    .text-information-card {
      display: flex;
      justify-content: space-between;
    }
    .test-information-header {
      display: flex;
      align-content: center;
      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0 5px;
        color: #f24a55;
        margin-top: 1px;
      }
      .el-button {
        border: 0;
        padding: 0 4px 0 12px;
        min-height: 30px;
        &:hover {
          background-color: #fff;
        }
        &:active {
          background-color: #fff;
        }
        &:focus {
          background-color: #fff;
        }
        .edit-icon {
          display: flex;
          align-items: center;

          img {
            width: 15px;
            height: 15px;
          }
          p {
            color: #828282;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
